import PropTypes from "prop-types"
import styled from "styled-components"
import {
  whiteTheme,
  brandTertiaryTrans10Theme,
  brandOffWhiteTheme,
} from "../../theme"

const Section = styled.section`
  display: flex;
  background-color: ${({ tint }) => (tint ? tint : whiteTheme)};  
  width: 100%;  
  align-items: center;
  flex-direction: column;
  clip-path: ${({ clipPath }) => (clipPath ? clipPath : "")};
  overflow: ${({ noOverflow }) => (noOverflow ? "" : "hidden")};
  ${({ theme }) => theme.se`
    padding: 50px 20px;
    &.communicate-section{
      padding-bottom: 0px;
    }
    &.manage-media-section{
      padding-top: 40px;
      padding-bottom: 30px;
    }
    &.download-app-section{
      padding-bottom: 0px;
      padding-top: 30px;
    }
    &.testimonial-wrapper-padding{
    padding: 20px 20px 0px;
  }
  `}

  ${({ theme }) => theme.tablet`
    padding: 40px 20px;
    
    &.padding-tb-0 {
      padding-top: 0;
      padding-bottom: 0;
    }

    &.padding-t-0 {
      padding-top: 0;
    }

    &.padding-b-0 {
      padding-bottom: 0;
    }
    &.graphic-image-container .graphic-image{
    margin-bottom: 30px;
  }
  &.power-img-container .power-container{
    padding-bottom: 10px;
  }
  &.lead-capture-wrapper{
  padding: 10px 20px 80px  
}
&.reduced-padding-wrapper{
  padding: 0px 20px;
}
&.build-high-wrapper{
  padding: 80px 20px 50px;
}
&.manage-media-section{
   padding-top: 0px;
      padding-bottom: 20px;
}
     
    
    &.download-app-section{
      // padding-bottom: 50px;
      padding-top: 0px;
    }
  `}

  ${({ theme }) => theme.desktop`
   padding: 80px 20px;
   &.padding-b-30{
     padding-bottom: 30px;
   } .padding-b-30{
     padding-bottom: 30px;
   }
   &.view-plan-padding{
     padding-bottom: 40px;
   }
   &.testimonial-wrapper-padding{
     padding-top: 40px;
     padding-bottom: 40px;
   }
  &.communicate-section{
      padding-bottom: 50px;
    }
    &.manage-media-section{
      padding-top: 50px;
      padding-bottom: 50px;
    }&.download-app-section{
      padding-bottom: 50px;
      padding-top: 50px;
    }
  `}
`

Section.propTypes = {
  tint: PropTypes.bool,
  offWhite: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
}

Section.defaultProps = {
  tint: false,
  offWhite: false,
}

export default Section
